import { render, staticRenderFns } from "./CalendarLegend.vue?vue&type=template&id=b6223b56&scoped=true"
import script from "./CalendarLegend.vue?vue&type=script&lang=ts"
export * from "./CalendarLegend.vue?vue&type=script&lang=ts"
import style0 from "./CalendarLegend.vue?vue&type=style&index=0&id=b6223b56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6223b56",
  null
  
)

export default component.exports